/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { useContext, useState, useRef } from 'react';
import { StyledFilterComponentDiv } from './index.styles';
// import { ComponentProps } from './../../index.types';
import { AllFiltersComponent } from '../allFilters';
import { PriceModalComponent } from '../priceFilters/index.modal';
// import { PointsModalComponent } from '../../molecules/pointsFilter/index.modal';
import { AmenitiesModalComponent } from '../amenitiesFilters/index.modal';
import { BrandsModalComponent } from '../brandFilters/index.modal';
import { QuickFiltersComponent } from '../quickFilters';
import { SearchFilterContext, SearchResultAlertContext } from '../../index.context';
import {
  quickFiltersAndAmenitiesHiddenCodes,
  SearchFacetsConstants,
  SearchFacetsListCodes,
} from '../../index.constant';
import { PointsModalComponent } from '../pointsFilter/index.modal';
import { renderedData } from '../../organisms/searchResults';
import clsx from 'clsx';

declare module 'react' {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  interface HTMLAttributes<T> {
    custom_click_track_value?: string;
  }
}

const FiltersComponent: React.FC<{
  setFetchCurrencyConversionFactors: React.Dispatch<React.SetStateAction<boolean>>;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  filterUpdateData?: any;
  isStateSearch?: boolean;
  isDestinationSearch?: boolean;
  className?: string;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  tooltipRefElement?: any;
  setTooltipContent?: any;
  modalRefElement?: any;
}> = ({
  filterUpdateData,
  isStateSearch,
  isDestinationSearch,
  className,
  setFetchCurrencyConversionFactors,
  tooltipRefElement,
  setTooltipContent,
  modalRefElement,
}) => {
  const clickTrackingLoc = 'Phoenix Search Results';
  const { searchQueryState } = useContext(SearchFilterContext);
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const { isFlexibleDateSearch, isStateOrCountry, isMapViewEnabled } = useContext<any>(renderedData);
  const { searchResultAlerts } = useContext(SearchResultAlertContext);

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const amenities = searchQueryState?.filter?.filter(
    (key: any) => key.type.code === SearchFacetsListCodes.amenities
  )[0];
  const [isDragging, setIsDragging] = useState<boolean>(false);
  const [startX, setStartX] = useState<number>(0);
  const [scrollLeft, setScrollLeft] = useState<number>(0);
  const containerRef: any = useRef(null);

  /**  the below three functions are responsible for horizontal scrolling on mouse drag
   *   handleMouseDown, handleMouseMove, handleMouseUp
   **/
  const handleMouseDown = (e: any) => {
    setIsDragging(true);

    setStartX(e.pageX - containerRef.current.offsetLeft);
    setScrollLeft(containerRef.current.scrollLeft);
  };

  const handleMouseMove = (e: any) => {
    if (!isDragging) return;
    const x = e.pageX - containerRef.current.offsetLeft;
    const distance = x - startX;
    containerRef.current.scrollLeft = scrollLeft - distance;
  };

  const handleMouseUp = () => {
    setIsDragging(false);
  };

  return (
    <StyledFilterComponentDiv className={clsx('px-0 container sm-search-result-all-filter-component', className)}>
      <div
        className={clsx('row-1', isMapViewEnabled ? 'pt-0 map-1-container' : 'pt-3')}
        data-testid={'filtercomp-testid'}
        ref={containerRef}
        onMouseDown={handleMouseDown}
        onMouseMove={handleMouseMove}
        onMouseUp={handleMouseUp}
        onMouseLeave={handleMouseUp}
      >
        <div className="row-1-container">
          <div className="all-filters-container">
            <AllFiltersComponent
              hideAvailabiltyFilters={
                isFlexibleDateSearch || (searchResultAlerts.type && searchResultAlerts.type === 'warning')
              }
              hideTaxesToggle={isFlexibleDateSearch}
              hideDistanceFilters={isStateOrCountry}
              hidePriceFilters={
                isFlexibleDateSearch || (searchResultAlerts.type && searchResultAlerts.type === 'warning')
              }
              filterData={filterUpdateData && filterUpdateData?.facets}
              isStateSearch={isStateSearch}
              isDestinationSearch={isDestinationSearch}
              setFetchCurrencyConversionFactors={setFetchCurrencyConversionFactors}
              tooltipRefElement={tooltipRefElement}
              setTooltipContent={setTooltipContent}
              modalRefElement={modalRefElement}
            />
          </div>
          {!isFlexibleDateSearch ? (
            <div className="price-filter-container">
              {searchResultAlerts.type && searchResultAlerts.type === 'warning' ? (
                <div />
              ) : searchQueryState[SearchFacetsConstants.points] ? (
                <PointsModalComponent
                  filterData={filterUpdateData && filterUpdateData?.facets}
                  hideTaxesToggle={isFlexibleDateSearch}
                  setFetchCurrencyConversionFactors={setFetchCurrencyConversionFactors}
                />
              ) : (
                <PriceModalComponent
                  filterData={filterUpdateData && filterUpdateData?.facets}
                  hideTaxesToggle={isFlexibleDateSearch}
                  setFetchCurrencyConversionFactors={setFetchCurrencyConversionFactors}
                />
              )}
            </div>
          ) : (
            <div />
          )}
          {!quickFiltersAndAmenitiesHiddenCodes.includes(searchResultAlerts?.code ?? '') && (
            <div className="amenities-filter-container">
              <AmenitiesModalComponent
                filterData={filterUpdateData && filterUpdateData?.facets}
                setFetchCurrencyConversionFactors={setFetchCurrencyConversionFactors}
                tooltipRefElement={tooltipRefElement}
                setTooltipContent={setTooltipContent}
                modalRefElement={modalRefElement}
              />
            </div>
          )}
          <div
            className="brand-filters-container custom_click_track"
            {...{ custom_click_track_value: `${clickTrackingLoc}| Filter Selection: Brands |internal` }}
          >
            <BrandsModalComponent
              filterData={filterUpdateData && filterUpdateData?.facets}
              setFetchCurrencyConversionFactors={setFetchCurrencyConversionFactors}
            />
          </div>
          {!quickFiltersAndAmenitiesHiddenCodes.includes(searchResultAlerts?.code ?? '') &&
            amenities?.buckets?.length > 0 && (
              <>
                <span className="filter-divider"></span>
                <QuickFiltersComponent
                  filterData={filterUpdateData && filterUpdateData?.facets}
                  setFetchCurrencyConversionFactors={setFetchCurrencyConversionFactors}
                />
              </>
            )}
        </div>
      </div>
    </StyledFilterComponentDiv>
  );
};

export default FiltersComponent;
